/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../utils/Api";
import SyncLoader from "react-spinners/SyncLoader";

// ChatItem component to display each message
const ChatItem = ({ outgoing, avatar, message, time, seen }) => {
  const [theme] = useState(localStorage.getItem('theme'))

  return (
    <div className={`single-chat-item ${outgoing ? "outgoing" : ""}`}>
      <div className="user-avatar mt-1">
        <span className="name-first-letter">{avatar ? avatar[0] : "A"}</span>
        {avatar && <img src={avatar} alt="avatar" />}
      </div>
      <div className="user-message">
        <div className="message-content">
          {message.map((msg, index) => (
            <div className="single-message" style={{ marginRight: "13px" }} key={index}>
              {msg.text && <p dangerouslySetInnerHTML={{ __html: msg.text }} />}
            </div>
          ))}
        </div>
        <div className="message-time-status">
          <div className={`sent-time ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>{time}</div>
          {seen && (
            <div className="sent-status seen">
              <i className="bi bi-check"></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [authToken] = useState(localStorage.getItem("authToken"));
  const branchId = localStorage.getItem("branchId");
  const enrollId = localStorage.getItem("enrollId");

  // const defaultMessage = {
  //   text: ``,
  // };

  const fetchToken = async () => {
    try {
      const fd = new FormData();
      fd.append("programType", "getToken");

      const response = await api.post("/token/tokenCurl", fd);

      if (response.data.success) {
        setToken(response.data.data);
      } else {
        console.error("Error fetching token:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  };

  const fetchNotifications = async () => {
    if (!token) return;

    try {
      const fd = new FormData();
      fd.append("programType", "getNotifications");
      fd.append("authToken", authToken);
      fd.append("token", token);
      fd.append("branch", branchId);
      fd.append("enrollId", enrollId);

      const response = await api.post("/teacher/teacherCurl", fd, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(response);

      if (response.data?.data) {
        console.log(response);
        setNotifications(response.data.data);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      setNotifications([]);
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authToken) {
      fetchToken();
    }
  }, [authToken]);

  useEffect(() => {
    if (token) {
      fetchNotifications();
    }
  }, [token]);

  const notificationsWithDefaultMessage = [...notifications];


  function dateFormatter(dateValue) {
    return (dateValue.split('-').reverse().join('-'));
  }

  return (
    <div>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SyncLoader color="orange" size={12} aria-label="Loading Spinner" data-testid="loader" />
        </div>
      )}

      {!loading && (
        <div style={{ marginTop: "40px" }}>
          <div className="header-area" id="headerArea">
            <div className="container">
              <div className="header-content position-relative d-flex align-items-center justify-content-between">
                <div className="chat-user--info d-flex align-items-center">
                  <div className="back-button" style={{ marginLeft: "-10px", marginRight: "10px" }}>
                    <Link to="/home">
                      <i className="bi bi-arrow-left-short"></i>
                    </Link>
                  </div>
                  <div className="user-thumbnail-name d-flex align-items-center">
                    {/* <img
                      src="assets/img/bg-img/WhatsApp Image 2025-01-21 at 12.30.09 PM.jpeg"
                      alt="User Thumbnail"
                      className="user-thumbnail"
                    /> */}
                    <div className="info ms-1 d-flex justify-content-between align-items-center w-100">
                      <h5 className="mb-0">UPDATES</h5>
                      {/* <img
                        src="assets/img/bg-img/bluetick.png"
                        className="Bluetick"
                        alt="Bluetick"
                        style={{ width: "17px", height: "auto", marginLeft: "2px" }}
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="chat-content-wrap"
            style={{
              paddingTop: "60px",
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
              paddingBottom: "10px",
              marginBottom: "100px",
              marginLeft: "15px",
              marginRight: "0px"
            }}
          >
            {notificationsWithDefaultMessage.map((notification, index) => (
              <ChatItem
                key={index}
                outgoing={false}
                avatar="assets/img/bg-img/WhatsApp Image 2025-01-21 at 12.30.09 PM.jpeg"
                message={[{ text: notification.text || notification.remark }]}
                time={dateFormatter(notification.start_date)}
                seen={false}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
